import { Route, type LoaderFunctionArgs } from "react-router-dom";

import { queryClient } from "@/providers/QueryClient";
import { loadSearchTablePreferences } from "@/shared/domain/config/loaders/loadSearchTablePreferences";
import { makeFeatureFlagRedirectLoader } from "@/shared/routing/featureFlagRoute";

import { File } from "./File";
import { FilesPage } from "./FilesPage";

const FILES_FLAG_FALLBACK = "/search?target=files";

const gateLoader = makeFeatureFlagRedirectLoader(queryClient, {
  flagName: "release-feature-pages",
  redirectTo: FILES_FLAG_FALLBACK,
});

const preferencesLoader = loadSearchTablePreferences(
  queryClient,
  "file_search_table_preferences",
);

async function filesListLoader(args: LoaderFunctionArgs) {
  // Gate first; if the flag is off the response is a redirect we must return
  // verbatim so the gated UI never mounts.
  const gateResult = await gateLoader(args);
  if (gateResult) {
    return gateResult;
  }
  return preferencesLoader(args);
}

export const FilesRoutes = () => [
  <Route key="/" index loader={filesListLoader} element={<FilesPage />} />,
  <Route
    key="detail"
    path=":fileId/:workspaceId?"
    loader={File.loader(queryClient)}
    element={<File.Component />}
    errorElement={<File.ErrorBoundary />}
  />,
];
